var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.1402 1 1 4.1402 1 8C1 11.8598 4.1402 15 8 15C11.8598 15 15 11.8598 15 8C15 4.1402 11.8598 1 8 1ZM8 13.6C4.9123 13.6 2.4 11.0877 2.4 8C2.4 4.9123 4.9123 2.4 8 2.4C11.0877 2.4 13.6 4.9123 13.6 8C13.6 11.0877 11.0877 13.6 8 13.6Z",
    fill: "#16192C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1949 6H6.004C5.87033 6 5.74213 6.0531 5.64762 6.14762C5.5531 6.24213 5.5 6.37033 5.5 6.504C5.5 6.63766 5.5531 6.76586 5.64762 6.86037C5.74213 6.95489 5.87033 7.00799 6.004 7.00799H10.1949C10.3286 7.00799 10.4568 6.95489 10.5513 6.86037C10.6458 6.76586 10.6989 6.63766 10.6989 6.504C10.6989 6.37033 10.6458 6.24213 10.5513 6.14762C10.4568 6.0531 10.3286 6 10.1949 6Z",
    fill: "#16192C",
    stroke: "#16192C",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1949 9H6.004C5.87033 9 5.74213 9.0531 5.64762 9.14762C5.5531 9.24213 5.5 9.37033 5.5 9.504C5.5 9.63766 5.5531 9.76586 5.64762 9.86037C5.74213 9.95489 5.87033 10.008 6.004 10.008H10.1949C10.3286 10.008 10.4568 9.95489 10.5513 9.86037C10.6458 9.76586 10.6989 9.63766 10.6989 9.504C10.6989 9.37033 10.6458 9.24213 10.5513 9.14762C10.4568 9.0531 10.3286 9 10.1949 9Z",
    fill: "#16192C",
    stroke: "#16192C",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCondition);
export default __webpack_public_path__ + "static/media/condition.ce2e865c85c9552ab010edddadea9c83.svg";
export { ForwardRef as ReactComponent };